import type { UrlSort } from '../lib/useUrlState';

/**
 * A sortable `<th>`. Click to sort, click again to flip; the active column shows
 * the direction. Kept as a plain th + button rather than a DataTable abstraction
 * because these three tables have quite different cells (inline selects, owner
 * pickers, level chips) and only the HEADER behaviour is actually shared.
 *
 * `aria-sort` is set so the sort state is available to a screen reader, not just
 * as a glyph.
 */
export function SortHeader({
  label,
  sortKey,
  sort,
  className,
  title,
}: {
  label: string;
  sortKey: string;
  sort: UrlSort;
  className?: string;
  title?: string;
}) {
  const active = sort.key === sortKey;
  return (
    <th
      className={className}
      aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button
        type="button"
        className={`sort-th${active ? ' sort-th--active' : ''}`}
        onClick={() => sort.toggle(sortKey)}
        title={title ?? `Sort by ${label.toLowerCase()}`}
      >
        {label}
        <span className="sort-th__arrow" aria-hidden="true">
          {active ? (sort.dir === 'asc' ? '↑' : '↓') : ''}
        </span>
      </button>
    </th>
  );
}
